// Get user-friendly ACE field label (matches ACEMapping.page logic)
export const getAceLabel = (label, apiName) => {
  const labelMap = {
    // Required fields
    "Activity_Type__c": "Opportunity Type",
    "Amount__c": "Estimated AWS monthly recurring revenue",
    "Aws_Funding_Used__c": "Marketing development funds",
    "CloseDate__c": "Target close date",
    "Customer_Use_Case__c": "Use Case",
    "End_Customer_Name__c": "Customer company name",
    "End_Customer_HQ__c": "Country",
    "End_Customer_Industry__c": "Industry vertical",
    "End_Customer_Postal_Code__c": "Postal Code",
    "End_Customer_State__c": "State/Province",
    "End_Customer_Website__c": "Customer Website",
    "Opportunity_Name__c": "Partner project title",
    "Project_Delivery_Models__c": "Delivery Models",
    // Optional fields
    "Business_Title__c": "Customer title",
    "Description__c": "Additional comments",
    "End_Customer_AWS_Account_ID__c": "AWS account ID",
    "End_Customer_Duns_Number__c": "Customer data universal number system (DUNS)",
    "End_Customer_City__c": "City",
    "End_Customer_Billing_Address__c": "Address",
    "Marketing_Channels__c": "Marketing activity channel",
    "Marketing_Use_Cases__c": "Marketing activity use-case",
    "NextStep__c": "Next step",
    "Owner_Email__c": "Customer email",
    "Owner_First_Name__c": "Customer first name",
    "Owner_Last_Name__c": "Customer last name",
    "Owner_Phone__c": "Customer phone",
    "Partner_Primary_First_Name__c": "Partner primary first name",
    "Partner_Primary_Last_Name__c": "Partner primary last name",
    "Partner_Primary_Title_Business__c": "Partner primary title",
    "Partner_Primary_Email__c": "Partner primary email",
    "Partner_Primary_Phone__c": "Partner primary phone",
    "Primary_Needs_From_Aws__c": "Partner specific needs from AWS for Co-sell",
    "Partner_primary_need_from_AWS__c": "Partner primary need from AWS",
    "Customer_Business_Problem__c": "Customer business problem",
    "Solutions_offered__c": "Solutions offered",
    "Other_solution_description__c": "Other solution description",
    "AWS_products__c": "AWS products",
    "APN_programs__c": "APN programs",
    "Marketing_Source__c": "Opportunity source",
    "Sales_Activities__c": "Sales activities",
    "ACE_Stage__c": "Stage",
    "Partner_Sales_Contact_Name__c": "Partner contact name",
    "Partner_Sales_Contact_Email__c": "Partner contact email",
    "Competitive_Tracking__c": "Competitive tracking",
    "Other_Competitor_Names__c": "Other competitor names",
    "Marketing_Campaign__c": "Marketing campaign"
  };

  return labelMap[apiName] || label;
};

// Format field type for display (lowercase)
export const formatFieldType = (type) => {
  if (!type) return '';
  return type.toLowerCase();
};

// Field hints configuration - maps ACE field API names to hint text
const FIELD_HINTS = {
  "End_Customer_Duns_Number__c": "Customer DUNS is 9 digits. For example: 123456789",
  "End_Customer_Website__c": "Customer website: For example: www.connact.com",
  "Customer_Business_Problem__c": "Business problem must have at least 20 characters up to a recommended maximum of 1,000 characters.",
  "NextStep__c": "Next steps can have up to 255 characters.",
  "Amount__c": "AWS Pricing Calculator",
  "Description__c": "Additional comments can have up to 255 characters."
};

// Get hint text for a field
export const getFieldHint = (apiName) => {
  return FIELD_HINTS[apiName] || "";
};
